import { useState, useCallback } from 'react';
import { GetAllPromotions, getAllReviews } from '../services/api/methods.ts';
import { GetAllPromotionsResult, Promotion, Review } from '../services/api/types.ts';

export const useReview = () => {
    const [review, setReview] = useState<Review[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadReviews = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const result = await getAllReviews();
            setReview(result.Review);
        } catch (err: any) {
            setError('Ошибка при загрузке акций');
            console.error('Ошибка при загрузке акций', err);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        review,
        loading,
        error,
        loadReviews,
        setReview,
        setError
    };
};
